export default __webpack_public_path__ + "static/media/img-b-result-distance-int_en@2x.d247f588.jpg";